import React from 'react'
import './svactor.css'
function Svactorg() {
  return (
    <div style={{ width: "auto" }}>
      <svg
        style={{ width: "auto", height: "295" }}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M235.497 295.5L204.773 211.789L204.526 211.117L193.269 180.446L193.149 180.118L144.165 46.6561L144.044 46.3284H143.695H141.304H140.955L140.835 46.6561L91.851 180.118L91.7307 180.446L80.4737 211.117L80.227 211.789L49.5032 295.5H11.7246L123.718 0.5H161.283L273.275 295.5H235.497ZM81.6592 210.789L92.5492 181.118H192.45L203.341 210.789H81.6592Z"
          className="svc1"
        />
        <path
          style={{ width: "700px" }}
          d="M224.497 295.5L193.773 211.789L193.526 211.117L182.269 180.446L182.149 180.118L133.165 46.6561L133.044 46.3284H132.695H130.304H129.955L129.835 46.6561L80.851 180.118L80.7307 180.446L69.4737 211.117L69.227 211.789L38.5032 295.5H0.724638L112.718 0.5H150.283L262.275 295.5H224.497ZM70.6592 210.789L81.5492 181.118H181.45L192.341 210.789H70.6592Z"
          className="sv3"

          //
        />
      </svg>
    </div>
  );
}

export default Svactorg